import { call, put, delay } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { Auth } from "aws-amplify";

import * as MiniMessageBox from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzUpdatePassword(username: string, confirmation_code: string, password: string): Generator<any, any, any> {
  return yield Auth.forgotPasswordSubmit(username, confirmation_code, password);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzSetNewPasswordWorker(action: any): Generator<any, any, any> {
  const form = "UpdatePasswordForm";
  const { payload, navigate } = action;

  try {
    yield put(startSubmit(form));

    const { confirmation_code, password, username } = payload;

    yield call(authnzUpdatePassword, username, confirmation_code, password);
    yield put(stopSubmit(form));

    navigate("/");
    yield delay(200);
    yield put(
      MiniMessageBox.showMiniBoxMessage({ show: true, type: "success", message: "Your password was updated successfully. Please login." }),
    );
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    yield put(stopSubmit(form));
    yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error.message }));
  }
}
